module.exports = __webpack_public_path__ + "img/logo.707066de.png";